<template>
<div >

  <!-- <table class=" table is-bordered is-striped is-narrow is-hoverable is-fullwidth "> -->
  <table class=" table is-bordered is-striped is-narrow is-hoverable ">
    <th> # </th>
    <th>Hora</th>
    <th>Usuario </th>
    <th>se cambia  </th>
    <th>Aplicado a </th>
    <th>Antes</th>
    <th>Después</th>
    <tr v-for="movimiento in movimientos ">
      <td> {{ movimiento.id }} </td>
      <td> {{ movimiento.time }} </td>
      <td> {{ movimiento.usuario }} </td>
      <td> {{ movimiento.tCambio }} </td>
      <td> {{ movimiento.sujeto_id }} </td>
      <td v-html="cutText(movimiento.beforeChange )"></td>
      <td> {{ movimiento.afterChange }} </td>
    </tr>
  </table>

</div>
</template>

<script>

import searchMix from '@/components/mixins/mixin'
import moment from 'moment'
import axios from 'axios'

const { AbilityBuilder } = require('casl')

export default {
  data () {
    return {
      menuComponente: 'app-create',
      movimientos:[]

    }
  },
  created () {
    this.getHistory();
  },
  methods: {
    parseDate:function(data){
      return moment(data,'YYYY-MM-DD').format('DD-MM-YYYY');
    },
    cutText:function(data){
      if(data!=null){
        return data.slice(0,40);
      }
    },
    getHistory:function(){
      var estancia = this;
      axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/read', {
        select: '*',
        table: 'registro_movimientos',
        where: ' id > 0   ',
        condition: 'ORDER BY time DESC'
      })
        .then(function (response) {
          if (response.status == 200) {
            console.log('lo que llega del axios"');
            console.log(response.data);
            estancia.movimientos = response.data
          } else {
            console.log('error')
          }
        })
    }
  },
  mixins: [searchMix]

}
</script>

<style scoped>

</style>
